module.exports = __webpack_public_path__ + "static/media/paras_temple.f62c6e28.jpg";